import { render, staticRenderFns } from "./DniFieldLandingSantanderBusiness.vue?vue&type=template&id=8311859a&scoped=true&"
import script from "./DniFieldLandingSantanderBusiness.vue?vue&type=script&lang=ts&"
export * from "./DniFieldLandingSantanderBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./DniFieldLandingSantanderBusiness.vue?vue&type=style&index=0&id=8311859a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8311859a",
  null
  
)

export default component.exports